import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Checkmark({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Checkmark.Outline {...props} />
  ) : (
    <Checkmark.Solid {...props} />
  );
}

Checkmark.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Checkmark.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M6.70711 11.7072C6.31658 11.3167 5.68342 11.3167 5.29289 11.7072C4.90237 12.0977 4.90237 12.7309 5.29289 13.1214L8.9609 16.7896C9.35142 17.1801 9.98459 17.1801 10.3751 16.7896L18.4578 8.70728C18.8483 8.31675 18.8483 7.68359 18.4578 7.29306C18.0673 6.90254 17.4341 6.90254 17.0436 7.29306L9.668 14.6682L6.70711 11.7072Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
